<template>
    <div>
        <SearchBox ref="SearchBox">
            <el-form slot="form" :inline="true" ref="searchData" :model="searchParams" label-width="100px" class="unitWidth" size="small">
                <el-form-item label="安灯类型">
                    <el-select v-model="aTypeSelected" placeholder="请选择" clearable filterable @change="aTChange">
                        <el-option
                            v-for="atype in aTList"
                            :key="atype.id"
                            :label="atype.label"
                            :value="JSON.stringify(atype.value)">
                            <span style="float: left">{{atype.label}}</span>
                            <span v-if="atype.value.hasOwnProperty('contentList')" style="float: right; color: #8492a6; font-size: 13px">
                                ({{atype.value.contentList.length}})
                            </span>
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="安灯种类">
                    <el-select v-model="aCSelected" placeholder="请选择" clearable filterable>
                        <el-option
                            v-for="acontent in aCList"
                            :key="acontent.id"
                            :label="acontent.label"
                            :value="acontent.value">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="触发条件">
                    <el-input v-model.trim="arTrigger" placeholder="请输入"></el-input>
                </el-form-item>
                <el-form-item label="触发条件编号">
                    <el-input v-model.trim="arCode" placeholder="请输入"></el-input>
                </el-form-item>
                <el-form-item label="安灯级别">
                    <el-select v-model="arLevel" placeholder="请选择" clearable>
                        <el-option
                            v-for="level in andonLevelList"
                            :key="level.value"
                            :label="level.label"
                            :value="level.value">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="作用范围">
                    <el-select v-model="scopeSelected" placeholder="请选择" clearable @change="scopeChange">
                        <!--<el-option label="公司" value="company"></el-option>-->
                        <el-option label="工厂" value="factory"></el-option>
                        <el-option label="车间" value="shop"></el-option>
                        <el-option label="工段" value="vsm"></el-option>
                        <el-option label="产线" value="line"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="所属工厂">
                    <el-select v-model="fcIdSelected" placeholder="请选择" clearable filterable @change="fcChange"
                               :disabled="scopeSelected =='company'">
                        <el-option
                            v-for="factory in factoryList"
                            :key="factory.value"
                            :label="factory.label"
                            :value="factory.value">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="所属车间">
                    <el-select v-model="shopSelected" placeholder="请选择" clearable filterable @change="shopChange"
                               :disabled="scopeSelected =='factory'||scopeSelected=='company'">
                        <el-option
                            v-for="shop in shopList"
                            :key="shop.value"
                            :label="shop.label"
                            :value="shop.value">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="所属工段">
                    <el-select v-model="sectionSelected" placeholder="请选择" clearable filterable @change="sectionChange"
                               :disabled="scopeSelected =='shop'|| scopeSelected =='factory'||scopeSelected=='company'">
                        <el-option
                            v-for="section in sectionList"
                            :key="section.value"
                            :label="section.label"
                            :value="section.value">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="所属产线">
                    <el-select v-model="lineSelected" placeholder="请选择" clearable filterable @change="lineChange"
                               :disabled="scopeSelected =='shop'|| scopeSelected =='factory'||scopeSelected=='company'||scopeSelected=='vsm'">
                        <el-option
                            v-for="line in lineList"
                            :key="line.value"
                            :label="line.label"
                            :value="line.value">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="响应时间(分)">
                    <el-input v-model.trim="arResponseSpan" placeholder="请输入"></el-input>
                </el-form-item>
                <el-form-item label="处理时间(分)">
                    <el-input v-model.trim="arSolveSpan" placeholder="请输入"></el-input>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" @click="addRule">确定</el-button>
                </el-form-item>
            </el-form>
        </SearchBox>
    </div>
</template>

<script>
    export default {
        name: 'addAndonRule',
        data(){
            return{
                searchParams: {
                    param: {},
                    pageSize: 10,
                    page: 1,
                    pageCount: 0,
                },
                arTrigger:'',
                arCode:'',
                arResponseSpan:'',
                arSolveSpan:'',
                andonTypelist:[],
                aTypeSelected:'',
                aCSelected:'',
                arLevel:'',
                aTypeSelected:'',
                aCSelected:'',
                andonLeveLSelected:'',
                scopeSelected:'',
                //安灯级别
                andonLevelList: [
                    {
                        value: 1,
                        label: '一级'
                    },
                    {
                        value: 2,
                        label: '二级'
                    },
                    {
                        value: 3,
                        label: '三级'
                    }
                ],
                factoryTree:[],
                fcIdSelected: '',
                sectionSelected: '',
                shopSelected: '',
                lineSelected: ''
            }
        },
        computed: {
            factoryList: function() {
                var arr = []
                if(this.factoryTree != undefined && this.factoryTree.length > 0) {
                    for(var i = 0; i < this.factoryTree.length; i++) {
                        arr.push({
                            label: this.factoryTree[i].deptName,
                            id: this.factoryTree[i].deptID,
                            value: JSON.stringify(this.factoryTree[i]),
                            deptLevel: this.factoryTree[i].deptLevel,
                            parent: 0
                        })
                    }
                }
                return arr;
            },
            shopList: function() {
                var arr = []
                if(this.fcIdSelected != undefined && this.fcIdSelected.length > 0) {
                    var factory = JSON.parse(this.fcIdSelected)
                    var shops = factory.child
                    for(var i = 0; i < shops.length; i++) {
                        arr.push({
                            label: shops[i].deptName,
                            id: shops[i].deptID,
                            value: JSON.stringify(shops[i]),
                            deptLevel: shops[i].deptLevel,
                            parent: 0
                        })
                    }
                }
                return arr
            },
            sectionList: function() {
                var arr = []
                if(this.shopSelected != undefined && this.shopSelected.length > 0) {
                    var shop = JSON.parse(this.shopSelected)
                    var vsms = shop.child
                    for(var i = 0; i < vsms.length; i++) {
                        arr.push({
                            label: vsms[i].deptName,
                            id: vsms[i].deptID,
                            value: JSON.stringify(vsms[i]),
                            deptLevel: vsms[i].deptLevel,
                            parent: 0
                        })
                    }
                }
                return arr
            },
            lineList: function() {
                var arr = []
                if(this.sectionSelected != undefined && this.sectionSelected.length > 0) {
                    var vsm = JSON.parse(this.sectionSelected)
                    var lines = vsm.child
                    for(var i = 0; i < lines.length; i++) {
                        arr.push({
                            label: lines[i].deptName,
                            id: lines[i].deptID,
                            value: JSON.stringify(lines[i]),
                            deptLevel: lines[i].deptLevel,
                            parent: 0
                        })
                    }
                }
                return arr
            },
            aTList:function() {
                var arr = []
                if(this.andonTypelist != undefined && this.andonTypelist.length > 0) {
                    for(var i = 0; i < this.andonTypelist.length; i++) {
                        arr.push({
                            label: this.andonTypelist[i].typeName,
                            id: this.andonTypelist[i].id,
                            value: this.andonTypelist[i],
                            parent: 0
                        })
                    }
                }
                return arr;
            },
            aCList: function() {
                var arr = []
                if(this.aTypeSelected != undefined && this.aTypeSelected.length > 0) {
                    var aContent = JSON.parse(this.aTypeSelected)
                    var content = aContent.contentList
                    if(content != undefined) {
                        for (var i = 0; i < content.length; i++) {
                            arr.push({
                                label: content[i].content,
                                id: content[i].id,
                                value: JSON.stringify(content[i]),
                                parent: 0
                            })
                        }
                    }
                }
                return arr
            }
        },
        mounted() {
            this.init()
        },
        methods:{
            init(){
                this.getData()
                this.getAndonType()
            },
            fcChange:function(){
                this.shopSelected =''
                this.sectionSelected = ''
                this.lineSelected = ''
                this.getData();
            },
            shopChange:function(){
                this.sectionSelected = ''
                this.lineSelected = ''
                this.getData();
            },
            sectionChange:function(){
                this.lineSelected = ''
                this.getData();
            },
            lineChange:function(){
                this.getData();
            },
            scopeChange(){
                this.fcIdSelected=''
                this.shopSelected =''
                this.sectionSelected = ''
                this.lineSelected = ''
            },
            aTChange() {
                this.aCSelected = '';
            },
            addRule(){
                var self = this
                if(self.aTypeSelected ==undefined || self.aTypeSelected== ''){
                    self.$message.info("请选择分类！")
                    return
                }
                if(self.aCSelected == '' || self.aCSelected == undefined){
                    self.$message.info("请输入安灯种类！")
                    return
                }
                if(self.arTrigger ==''|| self.arTrigger == null){
                    self.$message.info("请输入触发条件")
                    return
                }
                if(self.arCode ==''|| self.arCode == null){
                    self.$message.info("请输入触发条件编号")
                    return
                }
                if(self.arLevel ==''|| self.arLevel == null){
                    self.$message.info("请选择级别")
                    return
                }
                if(self.scopeSelected =='' || self.scopeSelected == null){
                    self.$message.info("请选择范围")
                    return
                }
                if(self.scopeSelected =='factory' && !self.fcIdSelected){
                    self.$message.info("请选择到工厂级")
                    return
                }else if(self.scopeSelected =='shop' && !self.shopSelected){
                    self.$message.info("请选择到车间级")
                    return
                }else if(self.scopeSelected =='vsm' && !self.sectionSelected){
                    self.$message.info("请选择到工段级")
                    return
                }else if(self.scopeSelected =='line' && !self.lineSelected){
                    self.$message.info("请选择到产线级")
                    return
                }
                if(self.arResponseSpan =='' || self.arResponseSpan == null){
                    self.$message.info("请输入响应时间")
                    return
                }
                if(self.arSolveSpan =='' || self.arSolveSpan == null){
                    self.$message.info("请输入处理时间")
                    return
                }
                let queryParams = {
                    acCode:JSON.parse(self.aCSelected).acCode,
                    arCode:self.arCode,
                    arTrigger:self.arTrigger,
                    arLevel:self.arLevel,
                    arScope:self.scopeSelected,
                    arResponseSpan:self.arResponseSpan,
                    arSolveSpan:self.arSolveSpan
                }
                if(self.fcIdSelected != undefined && self.fcIdSelected != '') {
                    queryParams['fcCode'] = JSON.parse(self.fcIdSelected).deptCode
                }
                if(self.shopSelected != undefined && self.shopSelected != '') {
                    queryParams['shopCode'] = JSON.parse(self.shopSelected).deptCode
                }
                if(self.sectionSelected != undefined && self.sectionSelected != '') {
                    queryParams['sectionCode'] = JSON.parse(self.sectionSelected).deptCode
                }
                if(self.lineSelected != undefined && self.lineSelected != '') {
                    queryParams['lineCode'] = JSON.parse(self.lineSelected).deptCode
                }

                let options = {
                    method:'POST',
                    data:queryParams,
                    url:this.$api.addAndonRule
                }
                this.$http.request(options).then(response => {
                    if(response.status == 100){
                        self.$message.success("新增成功！！！")
                    }else{
                        self.$message.error(response.message)
                    }
                })
            },
            getAndonType(){
                let options = {
                    method: 'GET',
                    url: this.$api.getAndonRule
                }
                this.$http.request(options).then(response => {
                    this.andonTypelist = response.data
                })
            },
            getData(){
                var self = this
                let options = {
                    method: 'GET',
                    url : this.$api.departTree
                }
                this.$http.request(options).then(response => {
                    this.factoryTree = response.data
                    /*for (var i = 0; i < self.factoryTree.length; i++) {
                        if(self.factoryTree[i].deptID == self.role.factoryId){
                            self.fcIdSelected = JSON.stringify(self.factoryTree[i])
                        }
                    }*/
                })
            }
        }
    }
</script>

<style scoped>

</style>
